import { render } from "./JobStackDeploymentDetails.vue?vue&type=template&id=e61d2080&scoped=true"
import script from "./JobStackDeploymentDetails.vue?vue&type=script&lang=js"
export * from "./JobStackDeploymentDetails.vue?vue&type=script&lang=js"

import "./JobStackDeploymentDetails.vue?vue&type=style&index=0&id=e61d2080&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61d2080"]])

export default __exports__